<template>
  <div ref="wrapper" class="wrapper ">
    <!--头部-->
    <div ref="pagehead">
      <page-head title="最美网格长" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    </div>
    <div class="box_f1 content">
      <!--日期选择框-->
      <div class="box date-box">
        <div class="_title">评选日期</div>
        <DatePicker type="date" placeholder="请选择日期" v-model="date" style="width: 410px" :disabled="disabled"></DatePicker>
      </div>
      <div class="box member-item">
        <div class="_title">最美网格长</div>
        <div class="box_f1">
          <div v-for="(item,index) in memberList" class="box" style="margin-bottom: 20px">
            <Card :padding="0" class="box_f1">
              <div class="member-card">
                <!--卡片头部  控制展开隐藏-->
                <div class="card-title box">
                  <div class="box">
                    <div class="title-name">姓名</div>
                    <Input v-model="item.name" style="width: 300px"/>
                  </div>
                  <div @click="changeContent(item,index)" style="flex:1;text-align: right">
                    <div v-if="item.isShow">收起详情<i class="iconfont icon--icon_arrow_up"></i>
                    </div>
                    <div v-else>
                      展开详情
                      <i class="iconfont icon--icon_arrow_up" style="transform: rotate(180deg);"></i>
                    </div>
                  </div>

                </div>
                <div class="member-detail" v-if="item.isShow">
                  <!--昵称-->
                  <div class="box" style="margin-bottom: 20px">
                    <div class="detail-title">昵称</div>
                    <div>{{item.nickname}}</div>
                  </div>
                  <!--证件照-->
                  <div class="box zhengjian">
                    <div class="detail-title">证件照</div>
                    <upload-img
                      :imgArr="item.imgArr"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="125"
                      :imgWidth="90"
                      @saveImg="saveImg($event,index)"
                      @delPic="delImg(index)"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                        <p>建议尺寸为</p>
                        <p>5:7</p>
                      </div>
                    </upload-img>
                  </div>
                  <!--编辑框-->
                  <div class="box edit">
                    <div class="detail-title">个人事迹</div>
                    <editor-box
                      ref="edit"
                      height="400px"
                      @editorContent="editorContent($event,index)"
                      :content="item.remark"
                      :showImg="false"
                      style="width: 970px"
                    >
                    </editor-box>
                  </div>
                  <!--附件-->
                  <div class="box fujian">
                    <div class="detail-title">附件</div>
                    <upload-img
                      :imgArr="item.picList"
                      :imgNumber="999"
                      :fixedNumber="[10,7]"
                      :imgHeight="70"
                      :imgWidth="100"
                      @saveImg="savePic($event,index)"
                      @delPic="delPic($event,index)"
                      class="upload"
                    >
                      <div class="uploadFujian">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>添加图片</p>
                      </div>
                    </upload-img>
                  </div>
                </div>
              </div>
            </Card>
            <!--删除按钮-->
            <div class="iconfont icon-quxiao1 del-icon" @click="delMember(index)"></div>
          </div>
          <div class="addBtn" @click="showSelect"><i class="iconfont icon-tianjia"></i>添加</div>
        </div>
      </div>
    </div>
    <select-people title="添加" :searchList="searchPeopleList" :btnLoading="false" ref="addModal" :btn-list="modalBtn"
                   @searchPeople="getSelectPeople" @submit="choicePeople"></select-people>
    <Modal v-model="showDel" title="删除" width="660px" @on-ok="onDelete">
      <div>该人员已发布为最美网格长，删除后不可恢复，确定删除吗？</div>
    </Modal>
  </div>
</template>

<script>
  import uploadImg from "../../../components/uploadImg";
  import editorBox from "../../../components/editorBox";
  import pageHead from '../../../components/head';
  import selectPeople from "../../../components/selectPeople"

  export default {
    name: 'beautyEdit',
    components: {
      pageHead,
      uploadImg,
      editorBox,
      selectPeople
    },
    data() {
      return {
        date: '',//评选日期
        disabled:false,//是否禁用日期选择
        btnList: [{
          name: '保存草稿',
          type: 'caogao',
          btnType: 'default',
          loading: false,
        }, {
          name: '发布',
          type: 'fabu',
          loading: false,
        }],//头部按钮
        imgNumber: 1,
        fixedNumber: [5, 7],
        memberList: [],//先锋人员数据
        searchPeopleList: [],//搜索的可添加的先锋人员
        modalBtn: [{
          name: '取消',
          type: 'text',
          value: 'cancel',
          loading: false,
        }, {
          name: '确定',
          type: 'primary',
          value: 'ok',
          loading: false,
        }],//可添加弹窗的底部按钮
        delIndex: '',//要删除的先锋的索引值
        showDel: false,//删除弹窗是否显示
        delPicList:[]
      }
    },
    methods: {
      // 点击右上角按钮
      handleBtn(type, index) {
        var time = this.$util.FormatDate(this.date.valueOf(), "yyyy-MM-dd")
        if (type == 'caogao') {
          this.submit(time, 0, index)
        } else if (type == 'fabu') {
          this.submit(time, 1, index)
        }
      },
      // 点击卡片头部  控制展开或者收起卡片
      changeContent(item,index) {
        //未展开  并且 没有数据时(没有数据通过有没有hasDetail判断)
        if (!item.isShow && !item.hasDetail) {
          this.getDetailByPeopleid(item)
        } else {
          item.isShow = !item.isShow
        }
      },
      getDetailByPeopleid(item) {
        var url = this.urlobj.getVanguardDetail(item.id)
        this.$get(url).then(res => {
          var info = res.rows[0]
          info.picList.reverse()
          item.unionId = info.unionId
          item.imgArr = info.headPicUrl?[{path:info.headPicUrl}]:[]
          item.isShow = true
          item.remark = info.context
          item.nickname =  info.userName,
          item.picList = info.picList.map(item => {
            return {
              path:item.picUrl,
              picId:item.id,
              id:''
            }
          })
          item.hasDetail = true
        })
      },
      //保存人图片
      saveImg() {
        this.memberList[arguments[1]].imgArr.splice(0, 1, arguments[0]);
      },
      //删除人图片
      delImg(index) {
        this.memberList[index].imgArr.splice(0, 1);
      },
      //保存附件
      savePic() {
        this.memberList[arguments[1]].picList.push(arguments[0]);
      },
      // 删除附件
      delPic() {
        var index = arguments[1],picIndex = arguments[0].index,item = this.memberList[index].picList[picIndex]
        if (item.picId) {
          this.delPicList.push({
            id:parseInt('-'+item.picId),
            picUrl:item.path
          })
          this.memberList[index].picList.splice(picIndex, 1);
        }else {
          this.memberList[index].picList.splice(picIndex, 1);
        }

      },
      // 编辑框
      editorContent() {
        this.memberList[arguments[1]].remark = arguments[0]
      },
      // 删除人员  存要删除的索引值  显示删除弹窗
      delMember(index) {
        if (this.memberList[index].id) {
          this.delIndex = index
          this.showDel = true
        }else {
          this.memberList.splice(index, 1)
        }
      },
      //确定删除
      onDelete() {
        var url = this.urlobj.delVanguard+'isDelete=1&idList='+this.memberList[this.delIndex].id
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.memberList.splice(this.delIndex, 1)
          this.showDel = false
        }).catch(e => {
          this.$Message.error('删除失败')
        })
      },
      // 判断条件   去获取可添加的人员数据
      showSelect() {
        if (!this.date) {
          this.$Message.warning('请选择时间')
        } else {
          this.getSelectPeople()
        }

      },
      // 获取可添加人员数据
      getSelectPeople(name = '') {
        var url = this.urlobj.getVanguardSelect(this.$util.FormatDate(this.date.valueOf(), "yyyy-MM-dd"))
        this.$get(url, {
          userName: name,
          pageNum: 1,
          pageSize: 21,
          comeType: 39
        }).then(res => {
          var unionIdList = this.memberList.map(item => {
            return item.unionId
          })
          this.searchPeopleList = res.rows.map(item => {
            return {
              pic: item.headPicUrl,
              name: item.realName,
              unionId: item.unionId,
              nickname:item.userName,
            }
          }).filter(item => {
            return unionIdList.indexOf(item.unionId) == -1
          })
          this.$refs.addModal.showModal = true
        })
      },
      //
      choicePeople(value, peopleList, index) {
        var memberList = peopleList.map(item => {
          return {
            id: '',
            name: item.name,
            unionId: item.unionId,
            nickname:item.nickname,
            imgArr: [],
            isShow: true,
            remark: '',
            picList: [],
            hasDetail:true,
          }
        })
        this.memberList = this.memberList.concat(memberList)
        this.$refs.addModal.showModal = false
      },
      //提交保存
      submit(time, status, btnIndex) {
        if (!this.memberList.length) {
          this.$Message.warning('请添加最美网格长')
          return
        }
        var url = this.urlobj.submitVanguard(time, status)
        var deedsList = this.memberList.map(item => {
          return {
            realName:item.name,
            id: item.id,//主键ID，不传或-1代表新增,
            unionId: item.unionId,//人员unionId,
            headPicUrl: item.imgArr.length?item.imgArr[0].path:'',//证件照图片URL,
            context: item.remark,//内容,
            comeType: 39,
            picList: item.picList.length?item.picList.map(_item => {
              return {
                id: _item.picId || '',
                picUrl: _item.path
              }
            }).concat(this.delPicList):[],//[{id:空值代表新增,picUrl:'图片URL'}...]
          }
        })
        this.btnList[btnIndex].loading = true
        this.$post(url,
          deedsList
        ).then(res => {
          this.btnList[btnIndex].loading = false
          this.$Message.success('提交成功')
          setTimeout(() => {
            this.$router.replace({name:'beauty',query:{status}})
          })
        }).catch(e => {
          this.btnList[btnIndex].loading = false
        })
      },
      // 检验表单
      checkForm() {
        var list = this.memberList.filter(item => {
          return item.hasDetail
        })
        var check = true
        for (var i = 0; i < list.length; i++) {
          if (!list[i].imgArr.length || !list[i].remark) {
            check = false;
            break;
          }
        }
        return check
      },
      // 获取当前日期下的最美网格长
      getDetailByDate(status) {
        var url = this.urlobj.getVanguard
        this.$post(url, {
          status, //0--草稿, 1--已发布,
          chooseTime: this.date,
          comeType: 39
        }).then(res => {
          this.memberList = res.rows[0].deedsList.map(item => {
            return {
              id: item.id,
              name: item.realName,
              unionId: item.unionId,
              imgArr: [],
              isShow: false,
              remark: '',
              picList: []
            }
          })
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.pagehead.scrollIntoView(false);
      })
      if (this.$route.query.time) {
        this.disabled = true
        this.date = this.$route.query.time
        this.getDetailByDate(this.$route.query.status)
      }
    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-input {
    font-size: 14px;
  }

  .content {
    padding: 20px;
    ._title {
      color: #333;
      margin-right: 20px;
      font-size: 16px;
    }
    .date-box {
      align-items: center;
      margin-bottom: 20px;
    }
    .member-item {

      .del-icon {
        align-self: center;
        color: #d22b2b;
        margin-left: 30px;
        font-size: 24px;
      }
      .member-card {
        padding: 0 20px;
        line-height: 1;
        font-size: 15px;
        .card-title {
          justify-content: space-between;
          align-items: center;
          color: #999;
          padding: 20px 0;
          .title-name {
            width: 70px;
            text-align: right;
            margin-right: 20px;
            color: #333;
            align-self: center;
          }
          .iconfont {
            color: #a8a8a8;
            margin-left: 10px;
            display: inline-block;
          }
        }
        .member-detail {
          .detail-title {
            width: 70px;
            text-align: right;
            margin-right: 20px;
            color: #333;
          }
          .zhengjian {
            margin-bottom: 20px;
            .uploadbox {
              width: 90px;
              height: 125px;
              border: 1px dashed #ddd;
              color: #b5b5b5;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
              padding: 10px 0;
              font-size: 14px;
              .icon-shangchuan1 {
                display: block;
                font-size: 37px;
              }
            }
          }
          .edit {
            margin-bottom: 20px;
          }
          .fujian {
            margin-bottom: 20px;
            .uploadFujian {
              width: 100px;
              height: 70px;
              border: 1px solid #ddd;
              color: #999;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
              padding: 10px 0;
              font-size: 14px;
              .icon-shangchuan1 {
                display: block;
                font-size: 37px;
              }
            }
          }
        }
      }
      .addBtn {
        width: 70px;
        height: 28px;
        text-align: center;
        line-height: 26px;
        background: #fff;
        border: 1px solid #ff7b44;
        color: #ff7b44;
        border-radius: 4px;
        .iconfont {
          color: #ff824e;
          margin-right: 5px;
        }
      }
    }
  }
</style>
